import { render, staticRenderFns } from "./MarketplaceIndex.vue?vue&type=template&id=8c21b482&scoped=true&"
import script from "./MarketplaceIndex.vue?vue&type=script&lang=js&"
export * from "./MarketplaceIndex.vue?vue&type=script&lang=js&"
import style0 from "../../less/complex.less?vue&type=style&index=0&id=8c21b482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c21b482",
  null
  
)

export default component.exports